import { gql } from "@apollo/client";

const UserQuery = gql`
  query AllUsers {
    allUsers {
      nodes {
        id
        appId
        email
        firstName
        lastName
        isActive
        isAdmin
        isExternal
        joinedOn
        uploadsByUserId {
          totalCount
        }
      }
    }
  }
`;

const hash = "b5ddb9e742adfc144c5654bf9a197cda608e0bf15330bdb17d48f6c10e5d1890";

export { UserQuery, hash };
